// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1ypmf","buttons":"PendingPaymentAlert_buttons__2MLIS"};